import { useWindowSize } from 'react-use';

const HEADER_PADDING = 2 * 16; // 2rem
const TITLE_SPACING = 50;
const FOOTER_PADDING = 2 * 16; // 2rem
const SHOWN_IN_SPACING = 60;

const SIDEBAR_WIDTH = 335;
const MODAL_PADDING = 4 * 16; // 4rem (left and right padding of modal)

const usePhotoWidth = () => {
  const { height: windowHeight = 0, width: windowWidth } = useWindowSize();
  const verticalOverlaySpacing = Math.floor((windowHeight / 100) * 10); // 10vh
  const horizOverlaySpacing = Math.floor((windowWidth / 100) * 10); // 10vw

  const maxHeightByScreenWidth =
    windowHeight -
    HEADER_PADDING -
    TITLE_SPACING -
    SHOWN_IN_SPACING -
    FOOTER_PADDING -
    verticalOverlaySpacing;

  const maxWidthByScreenWidth = Math.floor(maxHeightByScreenWidth * 1.5);

  const maxWidthByScreenHeight = Math.floor(
    windowWidth - SIDEBAR_WIDTH - MODAL_PADDING - horizOverlaySpacing
  );

  return Math.min(maxWidthByScreenWidth, maxWidthByScreenHeight);
};

export default usePhotoWidth;
